import api from './axios';

export const listEstoque = (filtros = {}) => api.get('/estoque/', { params: filtros });
export const getEstoqueBaixoCount = () => api.get('/estoque/baixo-count');
